// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-rate/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springRateEN: PageEntry = {
  id: "post.federrate",
  locale: "en",
  slug: "spring-rate",
  seo: {
    title: "Glossary: Spring rate explained simply | Dietz GmbH",
    description: "The spring rate, also known as the spring constant, indicates how strong a spring is, i.e. how much force is required to stretch or compress the spring by one unit. It is measured ",
  },
  type: "post",
  h1: "Glossary: Spring rate explained simply",
  intro: "The spring rate, also known as the spring constant, indicates how strong a spring is, i.e. how much force is required to stretch or compress the spring by one unit. It is measured in Newtons per metre (N/m). A higher spring rate means that the spring is stiffer and requires more force to deform it. The spring rate is a crucial parameter in the design of spring systems, as it is directly related to the spring force and other mechanical properties. It influences the dynamic properties of spring systems and is therefore of great importance in various engineering disciplines.",
  blocks: [

  ],
};
